import { createAction, props } from '@ngrx/store';
import { ChangeUserAccount } from '../../../settings/models/change-user-account';
import { SettingsModel } from '../../../core/models/settings.model';

export const getTimeZone = createAction(
  '[Core/Settings] Get Time Zone',
);

export const setTimeZone = createAction(
  '[Core/Settings] Set Time Zone',
  props<{timeZone: string}>()
);

export const loadDefaultTimeZone = createAction(
  '[Core/Settings] Load Default Time Zone',
);

export const getSettingsTags = createAction(
  '[Core/Settings] Get Settings Tags'
);

export const getSettingsTagsSuccess = createAction(
  '[Core/Settings] Get Settings Tags Success',
  props<{data: SettingsModel[]}>()
);

export const getSettingsTagsFailure = createAction(
  '[Core/Settings] Get Settings Tags Failure',
  props<{error: any}>()
);

export const getTag = createAction(
  '[Core/Settings] Get Tag',
  props<{tagName: string}>()
);

export const getTagSuccess = createAction(
  '[Core/Settings] Get Tag Success',
  props<{data: SettingsModel}>()
);

export const getTagFailure = createAction(
  '[Core/Settings] Get Tag Failure',
  props<{error: any}>()
);
export const getTags = createAction(
  '[Core/Settings] Get Tags',
  props<{tagNames: string[]}>()
);

export const getTagsSuccess = createAction(
  '[Core/Settings] Get Tags Success',
  props<{data: SettingsModel[]}>()
);

export const editTag = createAction(
  '[Core/Settings] Edit Tag',
  props<{tagName: string, tagValue: any}>()
);

export const editTagSuccess = createAction(
  '[Core/Settings] Edit Tag Success',
  props<{data: SettingsModel}>()
);

export const editTagFailure = createAction(
  '[Core/Settings] Edit Tag Failure',
  props<{error: any}>()
);
export const editTags = createAction(
  '[Core/Settings] Edit Tags',
  props<{tagNames: string[], tagValue: any}>()
);

export const editTagsSuccess = createAction(
  '[Core/Settings] Edit Tags Success',
  props<{data: SettingsModel[]}>()
);

export const editTagsFailure = createAction(
  '[Core/Settings] Edit Tags Failure',
  props<{error: any}>()
);

export const deleteTag = createAction(
  '[Core/Settings] Delete Tag',
  props<{tagName: string}>()
);

export const deleteTagSuccess = createAction(
  '[Core/Settings] Delete Tag Success',
  props<{tagName: string,}>()
);

export const deleteTagFailure = createAction(
  '[Core/Settings] Delete Tag Failure',
  props<{error: any}>()
);

export const deleteAccount = createAction('[Core/Settings] Delete Account');

export const changeUserAccount = createAction(
  '[Core/Settings] Change User Account',
  props<{data: ChangeUserAccount}>()
);

export const changeUserAccountSuccess = createAction(
  '[Core/Settings] Change User Account Success',
  props<{data: ChangeUserAccount}>()
);

export const changeUserAccountFailure = createAction(
  '[Core/Settings] Change User Account Failure',
  props<{error: any}>()
);
export const decodeFromToken = createAction(
  '[Core/Settings] Decode From Token'
);

export type SettingsActionsUnion = ReturnType<
  typeof getTimeZone |
  typeof setTimeZone |
  typeof loadDefaultTimeZone |
  typeof getSettingsTags |
  typeof getSettingsTagsSuccess |
  typeof getSettingsTagsFailure |
  typeof getTag |
  typeof getTagSuccess |
  typeof getTagFailure |
  typeof getTags |
  typeof getTagsSuccess |
  typeof editTag |
  typeof editTagSuccess |
  typeof editTagFailure |
  typeof editTags |
  typeof editTagsSuccess |
  typeof editTagsFailure |
  typeof deleteTag |
  typeof deleteTagSuccess |
  typeof deleteTagFailure |
  typeof deleteAccount |
  typeof changeUserAccount |
  typeof changeUserAccountSuccess |
  typeof changeUserAccountFailure |
  typeof decodeFromToken
  >;
